if (!customElements.get('th-collection-products')) {
  customElements.define('th-collection-products', class extends HTMLElement {
    constructor() {
      super();
      this.onChange = (event) => {
        if (event.target.matches('select')) this.form.requestSubmit();
      };
    }

    connectedCallback() {
      this.form = this.querySelector('[data-th-collection-form]');
      if (!this.form || typeof this.form.requestSubmit !== 'function') return;
      this.form.addEventListener('change', this.onChange);
      this.setAttribute('data-th-enhanced', '');
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this.onChange);
      this.removeAttribute('data-th-enhanced');
    }
  });
}
